import { type FC, useState } from 'react'
import { type ControllerRenderProps } from 'react-hook-form'

import { RxLpChCheckbox } from './RxLpChCheckbox'

export type CheckboxParams = {
  dataQaId?: string
  id: string
  label: string
  name: string
  value: string
}

export type CheckboxGroupFieldsetProps = {
  checkboxes: CheckboxParams[]
  className?: string
  onChange: ControllerRenderProps['onChange']
  value: (string | null)[]
}

export const RxLpChCheckboxGroupFieldset: FC<CheckboxGroupFieldsetProps> = ({
  checkboxes,
  className,
  onChange,
  value,
}) => {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- reports of something that will happen in runtime
  const [values, setValues] = useState<(string | null)[]>(value || [])

  return (
    <fieldset className={className}>
      {checkboxes.map((checkbox, index) => (
        <RxLpChCheckbox
          {...checkbox}
          checked={values.includes(checkbox.value)}
          key={checkbox.id}
          onChange={(event) => {
            const newValues = [...values]
            newValues[index] = event.target.checked ? event.target.value : null

            onChange(newValues)
            setValues(newValues)
          }}
        />
      ))}
    </fieldset>
  )
}
